export default "__VITE_ASSET__W1MTUuFk__"